import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import ky from 'ky';

import { setLatest } from '../redux/workBackendSlice';
import { initLocalDB, hasData, loadAllDb } from '../redux/dataBackend';
import { setCurrentUser } from '../redux/userDbSlice';
import useWorkBackend from './useWorkBackend';
import useInstallGoods from './useInstallGoods';

import { apiURL } from '../components/DigimagiProvider';
import { makeInitialUserData } from '../general';

const useInitilaizeDb = () => {
  const dispatch = useDispatch();
  const { authUser, latest } = useWorkBackend();
  const installGoods = useInstallGoods();

  const getInitialSetupData = async (userId: string, paletteId: string, folderId: string) => {
    console.log('initial data setup start')
    const query = await ky.get(`${apiURL}get_initial_setup_data`).json() as any;
    const goodsList = JSON.parse(query.data.goods_list) as [string, number][];
    const sendData = { list: goodsList };
    await installGoods({ sendData, paletteId, folderId, localUserId: userId, initialize: true });
  }
  const initializeExe = async (loginId: string | null) => {
    let userId = loginId;
    if (!loginId) {
      const db = await initLocalDB();
      const users = await db.getAll('users');
      if (users[0] && 'id' in users[0]) {
        userId = users[0].id;
        if (userId) localStorage.setItem('loginId', userId);
      }
    }
    if (await hasData()) {
      if (userId) {
        console.log('load existing data')
        dispatch(loadAllDb());
        dispatch(setCurrentUser(userId));
      } else makeInitialUserData(dispatch, authUser);
    } else {
      const baseData = makeInitialUserData(dispatch, authUser);
      if (baseData) getInitialSetupData(baseData.userId, baseData.paletteId, baseData.folderId);
    }
    dispatch(setLatest(true));
  }

  useEffect(() => {
    console.log(authUser)
    if (latest) return;
    if (!authUser) return;
    const loginId = authUser === 'noAuth' ? localStorage.getItem('loginId') : authUser.uid;
    console.log(loginId)
    initializeExe(loginId);
  }, [authUser, latest])
}

export default useInitilaizeDb;
